export default __webpack_public_path__ + "f1b5fb92386cc7649d3877daa19c663b.png";